import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

export default function LocationMap() {
  const { t } = useI18n();
  return (
    <section
      id="ubicacion"
      data-testid="location-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7 }}
        >
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4">{t.map.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">{t.map.title}</h2>
          <p className="mt-4 text-[#5C544F] leading-relaxed max-w-md">{t.map.desc}</p>
          <a
            href="https://www.google.com/maps?q=Rambla+del+Celler+93+Sant+Cugat"
            target="_blank" rel="noreferrer" data-testid="map-cta"
            className="mt-8 inline-flex items-center gap-3 px-7 py-3 rounded-full border border-[#2A2421]/20 text-[#2A2421] hover:bg-[#3e664c] hover:text-[#fdfcf9] hover:border-[#3e664c] transition-colors text-sm uppercase tracking-[0.18em]"
          >
            {t.map.cta}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8 }}
          className="rounded-3xl overflow-hidden border border-[#eae0df] shadow-[0_8px_30px_rgb(42,36,33,0.06)]"
          data-testid="map-embed-wrapper"
        >
          <iframe
            title="Ubicación Aura" data-testid="map-iframe"
            src="https://www.google.com/maps?q=Rambla+del+Celler+93+Sant+Cugat+del+Valles&output=embed"
            width="100%" height="460" style={{ border: 0 }}
            loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>
      </div>
    </section>
  );
}
